<div mat-dialog-title class="error-list-dialog-title">
  <h2 mat-dialog-title>Error list for machine {{ machineName }}</h2>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<p>
  Reference period: <strong>{{ fromFormatted }} / {{ toFormatted }}</strong> -
  Number of errors occurred: <strong>{{ errorList.length }}</strong>
</p>
<mat-dialog-content>
  <table class="errors-table">
    <thead>
      <th class="error-item-head">Timestamp</th>
      <th class="error-item-head">Description</th>
    </thead>
    <tbody *ngIf="errorList.length === 0">
      <tr>
        <td><span class="error-item">-</span></td>
        <td><span class="error-item">-</span></td>
      </tr>
    </tbody>
    <tbody *ngIf="errorList.length">
      <tr *ngFor="let error of errorList">
        <td>
          <span class="error-item"> {{ error.dateTimeState }}</span>
        </td>
        <td>
          <span class="error-item"> {{ error.description }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
